var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item){return _c('img',{key:item.id,staticClass:"v-icon",attrs:{"src":(_vm.base + "assets/yoga/images/videos/" + (item.alias) + ".png"),"alt":item.label,"title":item.label}})}))}
var staticRenderFns = []

export { render, staticRenderFns }